<div class="modal-v2 reset-password-modal">
  <div class="modal-v2-header">
    <div class="modal-v2-title">
      {{ 'global.change_password' | translate }}
    </div>

    <button
      class="modal-v2-close"
      (click)="dialogRef.close({ type: 'CANCEL' })"
    >
      <tc-icon iconType="close"></tc-icon>
    </button>
  </div>

  <div class="modal-v2-content">

    @if (state() === 'select-login') {
      @if (hasBothEmailAndPhoneNumber) {
        <div class="reset-password-title">
          {{ 'reset_password_modal.select_login' | translate }}
        </div>

        <div class="login-option">
          <tc-form-radio-input
            inputId="login-type-email"
            inputName="login-type"
            [inputValue]="customerService.customer.contactInfo.email"
            [inputFormControl]="loginControl"
          >
            <tc-icon class="login-icon" iconType="email"></tc-icon>
            <div class="login-text">
              {{ 'reset_password_modal.to_email' | translate }} <b>{{ customerService.customer.contactInfo.email }}</b>
            </div>
          </tc-form-radio-input>
        </div>

        <div class="login-option">
          <tc-form-radio-input
            inputId="login-type-phone"
            inputName="login-type"
            [inputValue]="customerService.customer.contactInfo.phoneNumber"
            [inputFormControl]="loginControl"
          >
            <tc-icon class="login-icon" iconType="phone"></tc-icon>
            <div class="login-text">
              {{ 'reset_password_modal.to_phone' | translate }} <b>{{ customerService.customer.contactInfo.phoneNumber | mask:PHONE_NUMBER_MASK }}</b>
            </div>
          </tc-form-radio-input>
        </div>

        @if (error()) {
          <div class="form__error">
            {{ error() }}
          </div>
        }

        <button
          class="btn form__submit reset-password-submit"
          (click)="state.set('otp')"
          type="submit"
        >
          {{ 'global.send_otp' | translate }}
        </button>
      } @else if (loginControl.invalid) {
        <div class="no-logins">
          {{ 'reset_password_modal.no_logins' | translate }}
        </div>
      }

    } @else {
      <tc-reset-password
        [login]="loginControl.getRawValue()"
        (success)="dialogRef.close('CONFIRM')"
      >
      </tc-reset-password>
    }
  </div>
</div>
